import React from 'react';

import { Skeleton } from '@mui/material';

import { IButtonImageV3 } from '../../../../interfaces/button';
import { IBdsIconButtonImage } from '../../../../interfaces/buttons';
import { GenericFunction } from '../../../../types/genericTypes';
import BdsIconButton from '../../Buttons/BdsIconButton/BdsIconButton';

import './InteractiveCard.scss';

interface IInteractiveCard {
  title: string;
  description?: string;
  illustration: IButtonImageV3;
  iconButton: IBdsIconButtonImage;
  iconPosition?: 'left' | 'top';
  loading?: boolean;
  action: GenericFunction;
}

const InteractiveCard = ({
  title,
  description,
  illustration,
  iconButton,
  iconPosition = 'left',
  loading,
  action
}: IInteractiveCard) => {
  return loading ? (
    <Skeleton className="ic-skeleton" height={144} variant="rectangular" />
  ) : (
    <div
      data-experience="new"
      className={`interactive-card-container flex flex-row p-8 justify-between ${
        iconPosition === 'left' ? 'items-center' : 'items-start'
      }`}
      data-testid="interactive-card"
      onClick={action}
    >
      <div className={`flex ${iconPosition === 'left' ? 'flex-row items-center gap-8' : 'flex-col items-start gap-2'}`}>
        <div className="flex flex-row justify-between" data-experience="new">
          <illustration.component className="ic-illustration" />
        </div>
        <div className="flex flex-col gap-4 items-baseline">
          <div className="ic-title">{title}</div>
          {description && <div className="ic-description">{description}</div>}
        </div>
      </div>
      <BdsIconButton icon={iconButton} action={action} variant="primary" size="sm" />
    </div>
  );
};

export default InteractiveCard;
